export const INVOICE_STATUS_NOT_PAID = 341;
export const INVOICE_STATUS_PAID = 342;
export const INVOICE_STATUS_PARTIALLY_PAID = 343;

export const BC_SYNC_STATUS_SYNCED = 'synced';
export const BC_SYNC_STATUS_FAILED = 'failed';
export const BC_SYNC_STATUS_NOT_SENT = 'not_sent';
